import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, ThemeIcon, Group, ActionIcon, Select, TextInput, Textarea, Button, Drawer, Badge, PinInput, Modal, Stack } from "@mantine/core";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    // Select,
    Input,
    // Button,
    Space,
    Card,
    Dropdown, message, Divider, Descriptions
} from "antd";
import { useState } from "react";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { useWallet } from "../../../Context/Walletcontext";
import { Admin_wallet_self_topin } from "../../../apicall";












const Selfwallettopup = ({ Headername }) => {
    const { user } = Userauthcontexthooks();
    const { refreshWallet } = useWallet();
    const [transferForm, setTransferForm] = useState({
        amount: "",
        remarks: "Admin wallet self top up",
    });
    const [mpin, setMpin] = useState("");
    const [transferLoading, setTransferLoading] = useState(false);
    const [mpinModal, setMpinModal] = useState(false);

    const handleTransferInput = (field, value) => {
        setTransferForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleTransferSubmit = () => {
        if (
            !transferForm.amount ||
            Number(transferForm.amount) <= 0
        ) {
            return message.error("Enter a valid topup amount.");
        }
        // Open MPIN modal here
        // call the mpin modal
        setMpinModal(true);
    };

    const confirmTransfer = async () => {
        if (mpin === '' || mpin.length !== 6) {
            message.error("Please enter your 6 digit MPIN");
            return;
        }

        const body = {
            amount: transferForm.amount,
            remarks: transferForm.remarks,
            mpin
        }
        // console.log(body);
        try {
            setTransferLoading(true);
            // API CALL HERE
            const data = await Admin_wallet_self_topin(body);
            if (data.success) {
                message.success(data.message);
                setMpinModal(false);
                setTransferForm({
                    amount: '',
                    remarks: '',
                })
                setMpin('');
                // setDistributordetails('');
                await refreshWallet(); // update the wallet in real time. 
            }

        } catch (error) {

            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setTransferLoading(false);
        }

    };



    return (
        <>
            <Topnavbar Headername={Headername} />

            <Container size={'xl'} mt={'sm'} >
                <Title c={'dimmed'}>Self Wallet Top-up</Title>
                <Text size="xs">Top-up admin wallet</Text>
            </Container >

            <Container size={'lg'} mt={'lg'} mb={'sm'}>
                <Paper shadow="sm" p={'xs'}>
                    <TextInput
                        label="Topup Amount"
                        placeholder="0.00"
                        withAsterisk
                        mt="xs"
                        value={transferForm.amount}
                        onChange={(e) =>
                            handleTransferInput("amount", e.target.value)
                        }
                    />
                    <Textarea
                        label="Remarks (Optional)"
                        placeholder="Write description here..."
                        mt="xs"
                        value={transferForm.remarks}
                        onChange={(e) =>
                            handleTransferInput("remarks", e.target.value)
                        }
                    />
                    <Button
                        fullWidth
                        variant="light"
                        mt="md"
                        onClick={handleTransferSubmit}
                    >
                        Topup Amount
                    </Button>
                </Paper>
            </Container>

            <Modal
                opened={mpinModal}
                onClose={() => setMpinModal(false)}
                title="Confirm Topup"
                centered
                radius="md"
                size="md"
            >
                <Stack>

                    <Paper withBorder p="md" radius="md">

                        <Stack gap={2}>

                            {/* <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    {transferForm?.userType}
                                </Text>

                                <Text fw={600}>
                                    {selectedUser?.userName}
                                </Text>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    {transferForm?.userType} Code
                                </Text>

                                <Badge>
                                    {selectedUser?.userCode}
                                </Badge>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Mobile
                                </Text>

                                <Text>
                                    {selectedUser?.mobile}
                                </Text>
                            </Group> */}

                            {/* <Divider /> */}

                            <Group justify="space-between">
                                <Text size="sm" fw={600}>
                                    Topup Amount
                                </Text>

                                <Text
                                    fw={700}
                                    size="lg"
                                    c="green"
                                >
                                    ₹ {Number(transferForm.amount).toLocaleString()}
                                </Text>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Remarks
                                </Text>

                                <Text>
                                    {transferForm.remarks || "-"}
                                </Text>
                            </Group>

                        </Stack>

                    </Paper>

                    {/* <Divider /> */}

                    <Stack align="center">

                        <Text fw={600}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setMpin}
                            mask
                            size="lg"
                        />

                    </Stack>

                    <Button
                        fullWidth
                        size="md"
                        loading={transferLoading}
                        // color="green"
                        onClick={confirmTransfer}
                    >
                        Confirm Topup ₹ {Number(transferForm.amount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal>
        </>
    )
}

export default Selfwallettopup;